import { Canvas, util, FabricImage, Path, Point } from 'fabric';

// TODO: Implement when have different masks Instantly apply mask to image // Add backup after
export const applyImageMask = (canvas: Canvas) => {
  const img = canvas.getActiveObject() as FabricImage;

  if (!img) return;

  img.set({
    // clipPath: getImageMask(shape, img.width, img.height),
    dirty: true,
    opacity: 1,
    lockRotation: true,
    selectable: true,
    originX: 'center',
    originY: 'center',
  });

  canvas.renderAll();
};

export const editImageCrop = async (canvas: Canvas, img: FabricImage, callback: () => void) => {
  if (img.clipPath === undefined) return;

  const { width: originalWidth, height: originalHeight } = img.getOriginalSize();

  const initialClipPath = img.clipPath as Path;
  const initialPath = initialClipPath.path;

  // console.group('Image Crop Debug');
  // console.log(img, 'initial Img');
  // console.log(originalWidth, originalHeight, 'ORGIGINAL img sizes');
  // console.log(scaledWidth, scaledHeight, 'SCALED img sizes');
  // console.log(1 / img.scaleY, 1 / img.scaleX, 'img scale');
  // console.log(initialClipPath, 'initial Clip Path');
  // console.log(initialPath, 'initial Path');
  // console.groupEnd();

  const imageX = img.getCenterPoint().x;
  const imageY = img.getCenterPoint().y;

  // console.log(imageX, imageY, 'imageX imageY');

  // Fixed adjustment calculations to account for image scale
  const topAdjustment = initialClipPath.top * img.scaleY;
  const leftAdjustment = initialClipPath.left * img.scaleX;

  // Create the crop area with proper positioning and size
  const cropArea = new Path(
    util.transformPath(
      initialPath,
      util.composeMatrix({
        scaleX: initialClipPath.scaleX,
        scaleY: initialClipPath.scaleY,
      }),
      new Point({ x: 0, y: 0 }),
    ),
    {
      absolutePositioned: true,
      id: 'crop-rect',
      angle: initialClipPath.angle + img.angle,
      stroke: '#00BA88',
      strokeWidth: 1,
      lockRotation: true,
      selectable: true,
      evented: true,
      originX: 'center',
      originY: 'center',
      left: imageX + leftAdjustment,
      top: imageY + topAdjustment,
      width: initialClipPath.getScaledWidth(),
      height: initialClipPath.getScaledHeight(),
      dirty: true,
      fill: null,
      scaleX: img.scaleX,
      scaleY: img.scaleY,
      flipX: initialClipPath.flipX,
      flipY: initialClipPath.flipY,
      zIndex: 9999999999,
      excludeFromBackup: true,
    },
  );

  canvas.add(cropArea);
  // console.log(cropArea, 'cropArea');

  // Store the original img properties to restore later
  const originalImgProps = {
    scaleX: img.scaleX,
    scaleY: img.scaleY,
    left: img.left,
    top: img.top,
    angle: img.angle,
    flipX: img.flipX,
    flipY: img.flipY,
  };

  img.set({
    objectCaching: false,
    clipPath: null,
    left: imageX,
    top: imageY,
    width: originalWidth,
    height: originalHeight,
    opacity: 0.5,
    lockRotation: true,
    selectable: true,
    evented: true,
    originX: 'center',
    originY: 'center',
    excludeFromBackup: true,
  });

  cropArea.setCoords();
  canvas.requestRenderAll();
  canvas.setActiveObject(cropArea);

  // Track selection state
  let imgSelected = false;
  let cropAreaSelected = true; // Initially the crop area is selected

  // Set the crop area as the active object

  // Track when image is selected/deselected
  img.on('selected', () => {
    imgSelected = true;
    // console.log('Image selected');
  });

  img.on('deselected', () => {
    setTimeout(() => {
      imgSelected = false;
      // console.log('Image deselected');

      // Apply crop if both objects are deselected
      if (!cropAreaSelected) {
        applyCrop();
      }
    }, 500);
  });

  // Track when crop area is selected/deselected
  cropArea.on('selected', () => {
    cropAreaSelected = true;
    // console.log('Crop area selected');
  });

  cropArea.on('deselected', () => {
    setTimeout(() => {
      cropAreaSelected = false;
      // console.log('Crop area deselected');

      // Apply crop if both objects are deselected
      if (!imgSelected) {
        applyCrop();
      }
    }, 500);
  });

  const applyCrop = () => {
    // Calculate offset between crop area and image center
    const cropCenter = cropArea.getCenterPoint();
    const imgCenter = img.getCenterPoint();

    const offsetX = cropCenter.x - imgCenter.x;
    const offsetY = cropCenter.y - imgCenter.y;

    // Calculate scaled dimensions
    // const cropScaledWidth = cropArea.getScaledWidth();
    // const cropScaledHeight = cropArea.getScaledHeight();

    // console.log('Crop dimensions:', cropScaledWidth, cropScaledHeight);
    // console.log('Offset from image center:', offsetX, offsetY);

    // Create new clip path
    const newClip = new Path(initialPath, {
      absolutePositioned: false,
      originX: 'center',
      originY: 'center',
      scaleX: (cropArea.scaleX * initialClipPath.scaleX) / img.scaleX,
      scaleY: (cropArea.scaleY * initialClipPath.scaleY) / img.scaleY,
      left: offsetX / img.scaleX,
      top: offsetY / img.scaleY,
      width: initialClipPath.width,
      height: initialClipPath.height,
      angle: cropArea.angle - img.angle,
      flipX: cropArea.flipX,
      flipY: cropArea.flipY,
      objectCaching: false,
    });

    // Restore original image properties
    img.set({
      angle: img.angle,
      flipX: originalImgProps.flipX,
      flipY: originalImgProps.flipY,
      clipPath: newClip,
      perPixelTargetFind: true, // ✅ Включаем попиксельное определение клика для изображений с маской
      selectable: true,
      evented: true,
      opacity: 1,
      dirty: true,
      excludeFromBackup: false,
    });

    // Unbind the events
    img.off('selected');
    img.off('deselected');
    cropArea.off('selected');
    cropArea.off('deselected');

    canvas.remove(cropArea);
    img.setCoords();

    // console.log('Final image with clip:', img);
    canvas.requestRenderAll();

    callback();
  };
};

export const removeMask = (canvas: Canvas) => {
  const img = canvas.getActiveObject() as FabricImage;

  if (!img) return;

  const { width: originalWidth, height: originalHeight } = img.getOriginalSize();

  img.set({
    clipPath: null,
    width: originalWidth,
    height: originalHeight,
  });

  canvas.renderAll();
};

export const deleteMaskImage = (canvas: Canvas, image: FabricImage) => {
  if (image.clipPath == null) return;

  const initialClipPath = image.clipPath as Path;
  const initialPath = initialClipPath.path;

  const pathObject = new Path(
    util.transformPath(
      initialPath,
      util.composeMatrix({
        scaleX: initialClipPath.scaleX,
        scaleY: initialClipPath.scaleY,
      }),
      new Point({ x: 0, y: 0 }),
    ),
    {
      absolutePositioned: true,
      id: image.id,
      selectable: true,
      evented: true,
      width: initialClipPath.getScaledWidth(),
      height: initialClipPath.getScaledHeight(),
      dirty: true,
      fill: '#000000',
      scaleX: image.scaleX,
      scaleY: image.scaleY,
      flipX: initialClipPath.flipX,
      flipY: initialClipPath.flipY,
      top: image.getY(),
      left: image.getX(),
      originX: 'center',
      originY: 'center',
      layer: image.layer,
      zIndex: image.zIndex,
      margin: {
        top: null,
        left: null,
        right: null,
        bottom: null,
      },
      space: {
        after: null,
        before: null,
        within: null,
      },
      originalText: image.originalText,
      shape_type: image.shape_type,
      inner_id: null,
      name: image.name,
      isLocked: false,
      is_truncated: false,
    },
  );

  canvas.add(pathObject);
  canvas.remove(image);
  canvas.renderAll();
  requestAnimationFrame(() => {
    canvas.setActiveObject(pathObject);
  });
};
